<template>
    <v-container>
        <div id="assemblies" v-if="showAssemblies">
            <v-card outlined class="mb-5">
                <v-card-title class="headline">
                    Assemblies
                </v-card-title>
                <v-card-text>
                    Welcome to your companies assemblies. This app is only available to the
                    management team (CEO and Project Manager). Each assembly is made up of tasks
                    that need to be completed by your team, you are in charge of delegating tasks
                    to your team in order to complete all of the assemblies. This app will let you
                    see which tasks have been complete for each assembly and which assemblies have
                    been completed.
                </v-card-text>
                <v-card-text v-html="assemblyHelpText"></v-card-text>
            </v-card>

            <v-card v-for="assembly in assemblies" :key="assembly.id" outlined class="mb-5">
                <v-card-title>{{ assembly.name }}</v-card-title>
                <v-card-text>
                    This assembly contains {{ assembly.tasks.length }} tasks.
                    <span class="green--text" v-if="assembly.complete"><b>This assembly is complete.</b></span>
                    <span class="red--text" v-else>This assembly is not complete!</span>
                </v-card-text>
                <v-list-item v-for="task in assembly.tasks" :key="task.id" dense>
                    <v-list-item-content>
                        <v-list-item-title>{{ task.action | kebabToTitle }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <span v-if="!assembly.complete">
                                <span :class="{ 'green--text': task.delegated, 'red--text': !task.delegated }">
                                    {{ task.delegated ? 'Delegated' : 'Not Delegated' }},
                                </span>
                                <span :class="{ 'green--text' : task.complete, 'red--text': !task.complete }">
                                    {{ task.complete ? 'Complete' : 'Not Complete' }}
                                </span>
                            </span>

                            <span v-if="!assembly.complete && roleLevel == 'pm'">
                                &#9679;
                            </span>

                            <span v-if="roleLevel == 'pm'">
                                For {{ task.roles.join(" or ") }}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="roleLevel == 'pm' && !assembly.complete">
                        <v-btn outlined color="primary" small @click="delegateTask(assembly, task)" :disabled="task.delegated">
                            <span v-if="!task.delegated">Delegate (1AP)</span>
                            <span v-else-if="!task.complete">Delegated</span>
                            <span v-else>Completed</span>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-card-actions v-if="roleLevel == 'ceo'">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" v-if="!assembly.delegated" @click="delegateAssembly(assembly)">Delegate to PM (1AP)</v-btn>
                    <v-btn text disabled v-else>Delegated to PM</v-btn>
                </v-card-actions>
            </v-card>

            <p type="info" v-if="assemblies.length <= 0">
                <i>There are no assemblies here!</i>
            </p>

            <delegate-dialog v-model="showDelegateDialog" :task="delegateDialogTask" :assembly="delegateDialogAssembly"/>
        </div>
    </v-container>
</template>

<script>
import DelegateDialog from '../components/DelegateDialog.vue';
import { mapState } from 'vuex';
import { kebabToTitle } from '../util';

export default {
    data: () => ({
        delegateDialogTask: null,
        delegateDialogAssembly: null,
        showDelegateDialog: false
    }),
    components: {
        DelegateDialog,
    },
    computed: {
        ...mapState({
            rawAssemblies: state => state.assemblies
        }),
        roleLevel() {
            var roleLevel = (this.$store.state.role ? this.$store.state.role.level : 'team') || 'team';
            return roleLevel;
        },
        showAssemblies() {
            return this.roleLevel == "ceo" || this.roleLevel == "pm" || this.roleLevel == 'sm';
        },
        assemblies() {
            if (this.roleLevel == "ceo") {
                return this.rawAssemblies;
            } else if (this.roleLevel == "pm") {
                return this.rawAssemblies.filter(a => a.delegated);
            } else {
                return [];
            }
        },
        assemblyHelpText() {
            var text = "";

            if (this.roleLevel == "ceo") {
                text += "As a CEO, you need to delegate assemblies to your project manager so that they can delegate individual tasks to their team. ";
                text += "You have a total of " + this.assemblies.length + " assemblies to manage.";
            } else if (this.roleLevel == "pm") {
                text += "As a Project Manager, you need to take assemblies that have been given to ou by your CEO and delegate tasks to your team. ";
                text += "You have " + this.assemblies.length + " assemblies at the moment. Your CEO may give you more assemblies throughout the game.";
            }

            return text;
        }
    },
    methods: {
        delegateAssembly(assembly) {
            this.$socket.client.emit("delegate", {
                type: "assembly",
                assembly: assembly.id
            });
        },
        delegateTask(assembly, task) {
            if (this.roleLevel != 'pm') { return; }
            if (task.delegated) { return; }

            this.delegateDialogTask = task;
            this.delegateDialogAssembly = assembly;
            this.showDelegateDialog = true;
        }
    },
    filters: {
        kebabToTitle
    }
}
</script>
